var exports = {
  "Z": "BannerDescription__CLePVA",
};

module.exports = exports;
